export enum SearchTypes {
  Id = 'SearchId',
  Country = 'SearchCountry',
  Search = 'Search',
  Address = 'SearchAddress',
  Location = 'SearchLocation',
  Position = 'SearchPosition',
  Rectangle = 'SearchRectangle',
  Routing = 'SearchRouting',
  Geocoding = 'SearchGeocoding'
}
